import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import './AttestationForm.css';

const AttestationForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const orderData = location.state;

  const [formData, setFormData] = useState({
    tseName: 'TSE Consultant INT',
    tseDirecteur: 'Mr Ahmed Fnaiech',
    tseAdresse: '',
    tseNumeroFiscal: '',
    tseTelephone: '',
    tseSiteWeb: '',
    tseRepresentant: 'Mr Ahmed Fnaiech',

    societeNom: '',
    societeAdresse: '',
    societeNumeroFiscal: '',
    societeTelephone: '',
    societeRepresentant: '',

    datePaiement: new Date().toISOString().split('T')[0],
    montantPaiement: orderData?.totalPrice || '',
    moyenPaiement: 'virement bancaire',
    lieuSignature: 'Tunis',
    dateSignature: new Date().toISOString().split('T')[0]
  });

  const [errors, setErrors] = useState({});
  const [isGenerating, setIsGenerating] = useState(false);

  const numberToFrench = (num) => {
    const units = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
    const teens = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
    const tens = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante-dix', 'quatre-vingt', 'quatre-vingt-dix'];
    
    if (num === 0) return 'zéro';
    
    const integerPart = Math.floor(num);
    const decimalPart = Math.round((num - integerPart) * 1000);
    
    let result = '';
    
    if (integerPart >= 1000) {
      const thousands = Math.floor(integerPart / 1000);
      if (thousands === 1) {
        result += 'mille ';
      } else {
        result += units[thousands] + ' mille ';
      }
    }
    
    const remainder = integerPart % 1000;
    if (remainder >= 100) {
      const hundreds = Math.floor(remainder / 100);
      if (hundreds === 1) {
        result += 'cent ';
      } else {
        result += units[hundreds] + ' cent ';
      }
    }
    
    const lastTwo = remainder % 100;
    if (lastTwo >= 20) {
      const ten = Math.floor(lastTwo / 10);
      const unit = lastTwo % 10;
      result += tens[ten];
      if (unit > 0) {
        result += '-' + units[unit];
      }
    } else if (lastTwo >= 10) {
      result += teens[lastTwo - 10];
    } else if (lastTwo > 0) {
      result += units[lastTwo];
    }
    
    result += ' dinars';
    
    if (decimalPart > 0) {
      result += ' et ' + decimalPart + ' millimes';
    }
    
    return result.trim().charAt(0).toUpperCase() + result.trim().slice(1);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.tseAdresse.trim()) newErrors.tseAdresse = "L'adresse TSE est obligatoire";
    if (!formData.tseNumeroFiscal.trim()) newErrors.tseNumeroFiscal = "Le numéro fiscal TSE est obligatoire";
    if (!formData.tseTelephone.trim()) newErrors.tseTelephone = "Le téléphone TSE est obligatoire";
    if (!formData.tseSiteWeb.trim()) newErrors.tseSiteWeb = "Le site web TSE est obligatoire";

    if (!formData.societeNom.trim()) newErrors.societeNom = "Le nom de la société est obligatoire";
    if (!formData.societeAdresse.trim()) newErrors.societeAdresse = "L'adresse de la société est obligatoire";
    if (!formData.societeNumeroFiscal.trim()) newErrors.societeNumeroFiscal = "Le numéro fiscal de la société est obligatoire";
    if (!formData.societeTelephone.trim()) newErrors.societeTelephone = "Le téléphone de la société est obligatoire";
    if (!formData.societeRepresentant.trim()) newErrors.societeRepresentant = "Le représentant légal est obligatoire";

    if (!formData.datePaiement) newErrors.datePaiement = "La date de paiement est obligatoire";
    if (!formData.montantPaiement) newErrors.montantPaiement = "Le montant est obligatoire";
    if (!formData.lieuSignature.trim()) newErrors.lieuSignature = "Le lieu de signature est obligatoire";
    if (!formData.dateSignature) newErrors.dateSignature = "La date de signature est obligatoire";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleGeneratePDF = () => {
    if (!validateForm()) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    setIsGenerating(true);

    try {
      const doc = new jsPDF();
      
      const marginLeft = 15;
      const marginRight = 195;
      let y = 20;

      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text("ATTESTATION DE PAIEMENT D'AVANCE", 105, y, { align: 'center' });
      y += 15;

      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      
      const mainText = `Je soussigné, ${formData.tseDirecteur}, en tant que Directeur de ${formData.tseName}, société légalement constituée et opérant conformément à la réglementation en vigueur, atteste par la présente avoir reçu de la part de la société ${formData.societeNom}, en date du ${formatDate(formData.datePaiement)}, un paiement d'un montant total de ${parseFloat(formData.montantPaiement).toLocaleString('fr-TN')} TND (${numberToFrench(parseFloat(formData.montantPaiement))}) par ${formData.moyenPaiement}.`;
      
      const splitText = doc.splitTextToSize(mainText, marginRight - marginLeft);
      doc.text(splitText, marginLeft, y);
      y += splitText.length * 5 + 5;

      const text2 = "Ce paiement correspond à une première avance contractuelle, effectuée conformément aux termes et conditions du contrat liant les deux parties, et s'inscrit dans le cadre de l'exécution des prestations convenues.";
      const splitText2 = doc.splitTextToSize(text2, marginRight - marginLeft);
      doc.text(splitText2, marginLeft, y);
      y += splitText2.length * 5 + 5;

      const text3 = "La présente attestation est établie en toute bonne foi, à des fins administratives, comptables et fiscales, pour servir et valoir ce que de droit.";
      const splitText3 = doc.splitTextToSize(text3, marginRight - marginLeft);
      doc.text(splitText3, marginLeft, y);
      y += splitText3.length * 5 + 10;

      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text('INFORMATIONS DES PARTIES', 105, y, { align: 'center' });
      y += 10;

      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text(formData.tseName, marginLeft, y);
      y += 6;

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(`Adresse: ${formData.tseAdresse}`, marginLeft, y);
      y += 5;
      doc.text(`Numéro fiscal: ${formData.tseNumeroFiscal}`, marginLeft, y);
      y += 5;
      doc.text(`Téléphone fixe: ${formData.tseTelephone}`, marginLeft, y);
      y += 5;
      doc.text(`Site web: ${formData.tseSiteWeb}`, marginLeft, y);
      y += 5;
      doc.text(`Représentant légal: ${formData.tseRepresentant}`, marginLeft, y);

      const rightX = 110;
      let yRight = y - 25;

      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text(formData.societeNom, rightX, yRight);
      yRight += 6;

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(`Adresse: ${formData.societeAdresse}`, rightX, yRight);
      yRight += 5;
      doc.text(`Numéro fiscal: ${formData.societeNumeroFiscal}`, rightX, yRight);
      yRight += 5;
      doc.text(`Téléphone fixe: ${formData.societeTelephone}`, rightX, yRight);
      yRight += 5;
      doc.text(`Représentant légal: ${formData.societeRepresentant}`, rightX, yRight);

      y += 15;

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(`Fait à ${formData.lieuSignature}, le ${formatDate(formData.dateSignature)}`, marginLeft, y);
      y += 8;

      doc.text('Pour TSE Consultant INT', marginLeft, y);
      y += 10;

      doc.setFont('helvetica', 'bold');
      doc.text(formData.tseDirecteur, marginLeft, y);
      y += 5;
      doc.text('Directeur', marginLeft, y);
      y += 10;

      doc.setFont('helvetica', 'italic');
      doc.setFontSize(9);
      doc.text('Signature et cachet fiscal', marginLeft, y);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      const footer = `${formData.tseName} - ${formData.tseAdresse} - Tél: ${formData.tseTelephone} - ${formData.tseSiteWeb}`;
      doc.text(footer, 105, 285, { align: 'center' });

      const fileName = `Attestation_Paiement_${formData.societeNom.replace(/\s+/g, '_')}_${formData.dateSignature}.pdf`;
      doc.save(fileName);

      alert('✅ Attestation générée avec succès !');
      
      setTimeout(() => {
        navigate('/');
      }, 1000);

    } catch (error) {
      console.error('Erreur:', error);
      alert('❌ Erreur lors de la génération de l\'attestation');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="attestation-container">
      <div className="attestation-header">
        <h1>
          <i className="fas fa-file-contract"></i>
          Générer l'Attestation de Paiement d'Avance
        </h1>
        <p>Remplissez les informations pour générer votre attestation officielle</p>
      </div>

      <div className="attestation-content">
        <form className="attestation-form" onSubmit={(e) => e.preventDefault()}>
          
          <div className="form-section">
            <h2>
              <i className="fas fa-building"></i>
              Informations TSE Consultant INT
            </h2>

            <div className="form-row">
              <div className="form-group">
                <label>Nom de la société *</label>
                <input
                  type="text"
                  name="tseName"
                  value={formData.tseName}
                  onChange={handleChange}
                  disabled
                />
              </div>

              <div className="form-group">
                <label>Directeur *</label>
                <input
                  type="text"
                  name="tseDirecteur"
                  value={formData.tseDirecteur}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>

            <div className="form-group">
              <label>Adresse *</label>
              <input
                type="text"
                name="tseAdresse"
                placeholder="Ex: Avenue Habib Bourguiba, Tunis"
                value={formData.tseAdresse}
                onChange={handleChange}
                className={errors.tseAdresse ? 'error' : ''}
              />
              {errors.tseAdresse && <span className="error-message">{errors.tseAdresse}</span>}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Numéro fiscal *</label>
                <input
                  type="text"
                  name="tseNumeroFiscal"
                  placeholder="Ex: 1234567/A/M/000"
                  value={formData.tseNumeroFiscal}
                  onChange={handleChange}
                  className={errors.tseNumeroFiscal ? 'error' : ''}
                />
                {errors.tseNumeroFiscal && <span className="error-message">{errors.tseNumeroFiscal}</span>}
              </div>

              <div className="form-group">
                <label>Téléphone fixe *</label>
                <input
                  type="tel"
                  name="tseTelephone"
                  placeholder="Ex: +216 71 123 456"
                  value={formData.tseTelephone}
                  onChange={handleChange}
                  className={errors.tseTelephone ? 'error' : ''}
                />
                {errors.tseTelephone && <span className="error-message">{errors.tseTelephone}</span>}
              </div>
            </div>

            <div className="form-group">
              <label>Site web *</label>
              <input
                type="url"
                name="tseSiteWeb"
                placeholder="Ex: https://www.tse-consultant-int.cloud"
                value={formData.tseSiteWeb}
                onChange={handleChange}
                className={errors.tseSiteWeb ? 'error' : ''}
              />
              {errors.tseSiteWeb && <span className="error-message">{errors.tseSiteWeb}</span>}
            </div>
          </div>

          <div className="form-section">
            <h2>
              <i className="fas fa-handshake"></i>
              Informations de la Société Cliente
            </h2>

            <div className="form-group">
              <label>Nom de la société *</label>
              <input
                type="text"
                name="societeNom"
                placeholder="Ex: Société ACME Tunisie"
                value={formData.societeNom}
                onChange={handleChange}
                className={errors.societeNom ? 'error' : ''}
              />
              {errors.societeNom && <span className="error-message">{errors.societeNom}</span>}
            </div>

            <div className="form-group">
              <label>Adresse *</label>
              <input
                type="text"
                name="societeAdresse"
                placeholder="Ex: Rue de la République, Sfax"
                value={formData.societeAdresse}
                onChange={handleChange}
                className={errors.societeAdresse ? 'error' : ''}
              />
              {errors.societeAdresse && <span className="error-message">{errors.societeAdresse}</span>}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Numéro fiscal *</label>
                <input
                  type="text"
                  name="societeNumeroFiscal"
                  placeholder="Ex: 9876543/B/N/000"
                  value={formData.societeNumeroFiscal}
                  onChange={handleChange}
                  className={errors.societeNumeroFiscal ? 'error' : ''}
                />
                {errors.societeNumeroFiscal && <span className="error-message">{errors.societeNumeroFiscal}</span>}
              </div>

              <div className="form-group">
                <label>Téléphone fixe *</label>
                <input
                  type="tel"
                  name="societeTelephone"
                  placeholder="Ex: +216 74 987 654"
                  value={formData.societeTelephone}
                  onChange={handleChange}
                  className={errors.societeTelephone ? 'error' : ''}
                />
                {errors.societeTelephone && <span className="error-message">{errors.societeTelephone}</span>}
              </div>
            </div>

            <div className="form-group">
              <label>Représentant légal *</label>
              <input
                type="text"
                name="societeRepresentant"
                placeholder="Ex: Mr/Mme Nom Prénom"
                value={formData.societeRepresentant}
                onChange={handleChange}
                className={errors.societeRepresentant ? 'error' : ''}
              />
              {errors.societeRepresentant && <span className="error-message">{errors.societeRepresentant}</span>}
            </div>
          </div>

          <div className="form-section">
            <h2>
              <i className="fas fa-money-check-alt"></i>
              Informations de Paiement
            </h2>

            <div className="form-row">
              <div className="form-group">
                <label>Date de paiement *</label>
                <input
                  type="date"
                  name="datePaiement"
                  value={formData.datePaiement}
                  onChange={handleChange}
                  max={new Date().toISOString().split('T')[0]}
                  className={errors.datePaiement ? 'error' : ''}
                />
                {errors.datePaiement && <span className="error-message">{errors.datePaiement}</span>}
              </div>

              <div className="form-group">
                <label>Montant (TND) *</label>
                <input
                  type="number"
                  name="montantPaiement"
                  placeholder="Ex: 5000.00"
                  value={formData.montantPaiement}
                  onChange={handleChange}
                  step="0.01"
                  min="0"
                  className={errors.montantPaiement ? 'error' : ''}
                />
                {errors.montantPaiement && <span className="error-message">{errors.montantPaiement}</span>}
              </div>
            </div>

            <div className="form-group">
              <label>Moyen de paiement *</label>
              <select
                name="moyenPaiement"
                value={formData.moyenPaiement}
                onChange={handleChange}
              >
                <option value="virement bancaire">Virement bancaire</option>
                <option value="chèque bancaire">Chèque bancaire</option>
                <option value="espèces">Espèces</option>
              </select>
            </div>
          </div>

          <div className="form-section">
            <h2>
              <i className="fas fa-pen-fancy"></i>
              Informations de Signature
            </h2>

            <div className="form-row">
              <div className="form-group">
                <label>Lieu de signature *</label>
                <input
                  type="text"
                  name="lieuSignature"
                  placeholder="Ex: Tunis"
                  value={formData.lieuSignature}
                  onChange={handleChange}
                  className={errors.lieuSignature ? 'error' : ''}
                />
                {errors.lieuSignature && <span className="error-message">{errors.lieuSignature}</span>}
              </div>

              <div className="form-group">
                <label>Date de signature *</label>
                <input
                  type="date"
                  name="dateSignature"
                  value={formData.dateSignature}
                  onChange={handleChange}
                  max={new Date().toISOString().split('T')[0]}
                  className={errors.dateSignature ? 'error' : ''}
                />
                {errors.dateSignature && <span className="error-message">{errors.dateSignature}</span>}
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={() => navigate('/')}
              disabled={isGenerating}
            >
              <i className="fas fa-times"></i>
              Annuler
            </button>
            <button
              type="button"
              className="btn-primary"
              onClick={handleGeneratePDF}
              disabled={isGenerating}
            >
              {isGenerating ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Génération en cours...
                </>
              ) : (
                <>
                  <i className="fas fa-file-pdf"></i>
                  Générer le PDF
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AttestationForm;